import {
  combineReducers,
  configureStore,
  PreloadedStateShapeFromReducersMapObject,
  Reducer,
} from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { api } from './api';
import { navigationReducer } from './navigation';
import { speakingSessionStore } from './speaking-session';
import { lrwSessionStore } from './lrw-session';

const reducers = {
  [api.reducerPath]: api.reducer,
  navigation: navigationReducer,
  speakingSession: speakingSessionStore.reducer,
  lrwSession: lrwSessionStore.reducer,
};

export const combinedReducer = combineReducers<typeof reducers>(reducers);

export const rootReducer: Reducer<RootState> = (state, action) => {
  return combinedReducer(state, action);
};

export const setupStore = (preloadedState?: PreloadedStateShapeFromReducersMapObject<RootState>) =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ immutableCheck: false }).concat(api.middleware),
    preloadedState,
  });

export const store = setupStore();

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof combinedReducer>;
export type AppDispatch = typeof store.dispatch;
export const useTypedDispatch = () => useDispatch<AppDispatch>();
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
